import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/course-detail/:type?',
    name: 'course-detail',
    component: () => import('../views/course-detail.vue')
  },
  {
    path: '/teacher-list',
    name: 'teacher-list',
    component: () => import('../views/teacher-list.vue')
  },
  {
    path: '/teacher-detail/:id?',
    name: 'teacher-detail',
    component: () => import('../views/teacher-detail.vue')
  },
  {
    path: '/teacher-home',
    name: 'teacher-home',
    component: () => import('../views/teacher-home.vue')
  },
  {
    path: '/online-course',
    name: 'online-course',
    component: () => import('../views/online-course.vue')
  },
  {
    path: '/class-course',
    name: 'class-course',
    component: () => import('../views/class-course.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.name === from.name && to.hash) {
      return {}
    }

    return { x: 0, y: 0 }
  }
})

export default router
